import axios from 'axios';

// Create an Axios instance
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor (optional)
axiosClient.interceptors.request.use(
  (config) => {
    // You can modify the config here (e.g., add authorization tokens)
    const accessToken = localStorage.getItem('accessToken'); // Get token from local storage
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`; // Set token in headers
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor (optional)
axiosClient.interceptors.response.use(
  (response) => {
    // You can manipulate the response here if needed
    return response.data; // Return just the data part of the response
  },
  async (error) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken && error.response?.status === 401) {
      // Remove access token from localStorage  
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');

      // Capture the current path (location) and pass it as a query parameter
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = `/login?redirectTo=${encodeURIComponent(currentPath)}`;
    }
    if(error.response?.data) {
      if(error.response.data instanceof Blob) {
        const text = await error.response.data.text();
        try {
          const json = JSON.parse(text);
          return Promise.reject({...json, status: error.status});
        } catch (e) {
          return Promise.reject({...e, status: error.status});
        }
      } else {
        return Promise.reject({...error.response.data, status: error.status});
      }
    }
    return Promise.reject(error);
  }
);

export default axiosClient;